<template>
  <a-layout-content>
    <a-row>
      <a-col :xs="24" :sm="12">
        <a-card title="上轮购价记录" >
          <div v-if="buycount != ''">
            <g2-pie :type="'pie'" :data="buycount" :axis-name="{name:'购价', value:'人数'}" :label-option="{show:true, offset: -20}"/>
          </div>
          <div v-else>
            <h4>暂无上轮购价记录</h4>
          </div>
        </a-card>
      </a-col>
      <a-col :xs="24" :sm="12">
        <a-card title="上轮售价记录" >
          <div v-if="soldcount != ''">
            <g2-pie :type="'pie'" :data="soldcount" :axis-name="{name:'售价', value:'人数'}" :label-option="{show:true, offset: -20}"/>
          </div>
          <div v-else>
            <h4>暂无上轮售价记录</h4>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </a-layout-content>
</template>
<script>
export default {
  data () {
    return {
      user: [],
      data: [],
      buycount: [],
      soldcount: []
    }
  },
  mounted () {
    this.$http
      .get('https://auction-api.joyland.top/system')
      .then(res => {
        this.data = res.data
        this.$http
          .get('https://auction-api.joyland.top/getcount?option=buy&lun=' + (res.data.lun - 1))
          .then(res => {
            this.buycount = res.data
          })
        this.$http
          .get('https://auction-api.joyland.top/getcount?option=sold&lun=' + (res.data.lun - 1))
          .then(res => {
            this.soldcount = res.data
          })
      })
  },
  methods: {
  }
}
</script>
